import axios from 'axios';
import concat from 'lodash/concat';
import uniqBy from 'lodash/uniqBy';

import { Plugins } from '@capacitor/core';
const { Storage } = Plugins;
import { BASE_URL } from '@/constants/constants';

const rootUrl = BASE_URL;

export default {
    state: {
        contacts_list: [],
        contact_types: []
    },
    
    actions: {
        clearContactsData({ commit }) {
            commit('setContacts', []);
            commit('setContactTypes', []);
        },

        fetchContacts({ commit, rootState }) {
            return new Promise((resolve, reject) => {
                let headers = {
                    'Authorization': rootState.authorization
                };

                axios.get(`${rootUrl}/account/application/2/contact`, { headers: headers }).then((response) => {
                    commit('setContacts', response.data);
                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
            });
        },

        fetchContactTypes({ commit, rootState }) {
            return new Promise((resolve, reject) => {
                let headers = {
                    'Authorization': rootState.authorization
                };

                axios.get(`${rootUrl}/account/application/2/contact_type`, { headers: headers }).then((response) => {
                    commit('setContactTypes', response.data);
                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
            });
        },

        getContactsData({ commit, dispatch }) {
            // gets contact_types from local storage

            return new Promise((resolve, reject) => {
                Storage.get({ key: 'contacts_list' }).then((response) => {
                    let contacts_list = JSON.parse(response.value);
                    
                    if (contacts_list) {
                        commit('setContacts', contacts_list);
                        dispatch('fetchContacts');
                        resolve();
                    } else {
                        reject();
                    }
                });
            });
        },

        getContactTypesData({ commit, dispatch }) {
            // gets contact_types from local storage

            return new Promise((resolve, reject) => {
                Storage.get({ key: 'contact_types' }).then((response) => {
                    let contact_types = JSON.parse(response.value);
                    
                    if (contact_types) {
                        commit('setContactTypes', contact_types);
                        dispatch('fetchContactTypes');
                        resolve();
                    } else {
                        reject();
                    }
                });
            });
        },

        updateContactDB({ commit, rootState }, data) {
            return new Promise((resolve, reject) => {
                let headers = {
                    'Authorization': rootState.authorization
                };

                axios.post(`${rootUrl}/account/application/2/contact/${data.id}`, data.content, { headers: headers }).then((response) => {
                    commit('updateContactStore', response.data);
                    resolve(response.data);
                }).catch((error) => {
                    reject(error);
                });
            });
        },

        createContactDB({ commit, rootState }, data) {
            return new Promise((resolve, reject) => {
                let headers = {
                    'Authorization': rootState.authorization
                };

                axios.put(`${rootUrl}/account/application/2/contact/`, data, { headers: headers }).then((response) => {
                    commit('updateContactStore', response.data);
                    resolve(response.data);
                }).catch((error) => {
                    reject(error);
                });
            });
        },

        deleteContactDB({ commit, rootState }, contactID) {
            return new Promise((resolve, reject) => {
                let headers = {
                    'Authorization': rootState.authorization
                };

                axios.delete(`${rootUrl}/account/application/2/contact/${contactID}`, { headers: headers }).then((response) => {
                    commit('deleteContactStore', contactID);
                    resolve(response.data);
                }).catch((error) => {
                    reject(error);
                });
            });
        }
    },

    getters: {
        getContactsList: (state, getters, rootState) => {
            // get a list of contacts for active subscription

            let contacts = state.contacts_list.filter((contact) => {
                let type = state.contact_types.find(type => type.id === contact.type);
                if (type) {
                    contact.type_name = type.name;
                }

                if (contact.subscriptions.includes(rootState.subscriptions.active_subscription.id) && contact.type_name) {
                    return contact;
                }
            });

            contacts.sort((a, b) => {
                return a.type_name.toLowerCase() > b.type_name.toLowerCase() ? 1 : -1;
            });

            return contacts;
        },

        getContactTypes: (state, getters, rootState) => {
            // get a list of contact types for active subscription

            let types = state.contact_types.filter((type) => {
                return type.subscriptions.includes(rootState.subscriptions.active_subscription.id);
            });

            types.sort((a, b) => {
                return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
            });

            return types;
        },

        getContact: (state) => (id) => {
            // get a specific contact

            let contact = state.contacts_list.find((contact) => {
                let type = state.contact_types.find(type => type.id === contact.type);
                if (type) {
                    contact.type_name = type.name;
                }

                return contact.id === id;
            });

            return contact;
        },
    },

    mutations: {
        setContacts(state, data) {
            state.contacts_list = data;
            
            Storage.set({
                key: 'contacts_list',
                value: JSON.stringify(data)
            });
        },

        updateContactStore(state, data) {
            let list = concat([data], state.contacts_list);
            list = uniqBy(list, 'id');

            state.contacts_list = list;

            Storage.set({
                key: 'contacts_list',
                value: JSON.stringify(list)
            });
        },

        deleteContactStore(state, contactID) {
            let list = state.contacts_list.filter((contact) => {
                return contact.id !== contactID;
            });

            state.contacts_list = list;

            Storage.set({
                key: 'contacts_list',
                value: JSON.stringify(list)
            });
        },

        setContactTypes(state, data) {
            state.contact_types = data;
            
            Storage.set({
                key: 'contact_types',
                value: JSON.stringify(data)
            });
        }
    },
};